import { useState, useEffect } from 'react';
import { api } from '../api';

const CAT_EQUIV = [
  { key: 'todos',       label: 'Todos'         },
  { key: 'AIRE',        label: '💨 Aire'        },
  { key: 'COMBUSTIBLE', label: '⛽ Combustible'  },
  { key: 'CABINA',      label: '🚗 Cabina'      },
  { key: 'ACEITE',      label: '🛢 Aceite'       },
];

const fmt = (n) => (n || 0).toLocaleString('es-EC', { minimumFractionDigits: 2 });

export default function TabEquivalencias() {
  const [datos,     setDatos]     = useState(null);
  const [cargando,  setCargando]  = useState(true);
  const [catFiltro, setCatFiltro] = useState('todos');
  const [expandido, setExpandido] = useState(null);
  const [busq,      setBusq]      = useState('');

  useEffect(() => { cargar('todos'); }, []);

  const cargar = async (cat) => {
    setCargando(true);
    setCatFiltro(cat);
    try {
      const data = await api.get(`/productos/equivalencias?filtro=${cat}`);
      setDatos(data.error ? null : data);
    } catch(e) { console.error(e); }
    finally { setCargando(false); }
  };

  const gruposFiltrados = (datos?.grupos || []).filter(g =>
    !busq ||
    g.aplicacion.toUpperCase().includes(busq.toUpperCase()) ||
    g.marcas.toUpperCase().includes(busq.toUpperCase()) ||
    g.items.some(i => i.codigo.toUpperCase().includes(busq.toUpperCase()))
  );

  const kpis = datos?.kpis;

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <h3 style={{ color: '#fff', margin: 0 }}>🔀 Cross-Reference de Filtros</h3>
          <p style={{ color: '#555', fontSize: 12, marginTop: 4 }}>
            Filtros equivalentes detectados via Filtrocorp · Identifica duplicados en compras
          </p>
        </div>
        <button
          style={{ background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: 13 }}
          onClick={() => cargar(catFiltro)}>
          🔄 Actualizar
        </button>
      </div>

      {/* KPIs */}
      {kpis && (
        <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
          {[
            { label: 'Grupos cross-ref',   val: kpis.total_grupos,                      color: '#a855f7' },
            { label: 'Items afectados',     val: kpis.total_items,                       color: '#ffc107' },
            { label: 'Con stock actual',    val: kpis.con_stock,                         color: '#4caf50' },
            { label: 'Sin stock',           val: kpis.total_grupos - kpis.con_stock,     color: '#555'    },
          ].map((k, i) => (
            <div key={i} style={{
              background: '#1e1e2e', borderRadius: 10, padding: '14px 18px',
              flex: 1, minWidth: 120, borderTop: `3px solid ${k.color}`,
            }}>
              <div style={{ color: k.color, fontSize: 22, fontWeight: 'bold', marginBottom: 4 }}>{k.val}</div>
              <div style={{ color: '#aaa', fontSize: 11 }}>{k.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Filtros + búsqueda */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
        {CAT_EQUIV.map(c => (
          <button key={c.key}
            style={{
              background: catFiltro === c.key ? '#1a1a2e' : '#1e1e2e',
              border: catFiltro === c.key ? '1px solid #a855f7' : '1px solid #2d2d44',
              borderRadius: 6, color: catFiltro === c.key ? '#a855f7' : '#888',
              padding: '6px 14px', cursor: 'pointer', fontSize: 12,
            }}
            onClick={() => cargar(c.key)}>
            {c.label}
            {kpis?.por_categoria?.[c.key] && (
              <span style={{ marginLeft: 6, background: '#2d2d44', borderRadius: 10, padding: '1px 6px', fontSize: 10, color: '#aaa' }}>
                {kpis.por_categoria[c.key]}
              </span>
            )}
          </button>
        ))}
        <input
          style={{ flex: 1, minWidth: 200, background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '7px 12px', fontSize: 13 }}
          placeholder="Buscar por aplicación, marca o código..."
          value={busq}
          onChange={e => setBusq(e.target.value)}
        />
      </div>

      {/* Lista */}
      {cargando ? (
        <p style={{ color: '#aaa', textAlign: 'center', padding: 40 }}>Cargando equivalencias...</p>
      ) : !datos ? (
        <p style={{ color: '#e63946' }}>Error cargando datos</p>
      ) : gruposFiltrados.length === 0 ? (
        <p style={{ color: '#555', textAlign: 'center', padding: 40 }}>Sin resultados</p>
      ) : (
        <>
          {gruposFiltrados.map((g) => {
            const abierto    = expandido === g.id_ref_cruzada;
            const tieneStock = g.stock_total > 0;
            return (
              <div key={g.id_ref_cruzada} style={{
                background: '#1a1a2e', borderRadius: 10, marginBottom: 8,
                border: `1px solid ${abierto ? '#a855f7' : '#2d2d44'}`,
                overflow: 'hidden',
              }}>
                {/* Header grupo */}
                <div
                  onClick={() => setExpandido(abierto ? null : g.id_ref_cruzada)}
                  style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', cursor: 'pointer', gap: 12 }}>

                  <span style={{ background: '#1a1a2e', color: '#a855f7', border: '1px solid #a855f7', borderRadius: 6, padding: '2px 8px', fontSize: 10, fontWeight: 'bold', flexShrink: 0 }}>
                    {g.categoria}
                  </span>

                  <span style={{ color: '#fff', fontSize: 13, flex: 1, fontWeight: '600' }}>
                    {g.aplicacion || `Ref. ${g.id_ref_cruzada}`}
                  </span>

                  <span style={{ color: '#555', fontSize: 11, flexShrink: 0 }}>{g.marcas}</span>

                  <span style={{ background: '#2d2d44', color: '#ffc107', borderRadius: 6, padding: '2px 8px', fontSize: 11, fontWeight: 'bold', flexShrink: 0 }}>
                    {g.n_items} items
                  </span>

                  <span style={{
                    background: tieneStock ? '#1a3a2a' : '#1a1a2e',
                    color: tieneStock ? '#4caf50' : '#555',
                    borderRadius: 6, padding: '2px 10px', fontSize: 11, flexShrink: 0,
                  }}>
                    {tieneStock ? `Stock: ${g.stock_total}` : 'Sin stock'}
                  </span>

                  <span style={{ color: '#555', fontSize: 14, flexShrink: 0 }}>{abierto ? '▲' : '▼'}</span>
                </div>

                {/* Detalle expandido */}
                {abierto && (
                  <div style={{ borderTop: '1px solid #2d2d44', padding: '14px 16px', background: '#0f0f1a' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 10 }}>
                      {g.items.map((item, j) => (
                        <div key={j} style={{
                          background: '#1a1a2e', borderRadius: 8, padding: '12px 14px',
                          borderLeft: `3px solid ${item.stock > 0 ? '#4caf50' : '#2d2d44'}`,
                        }}>
                          <div style={{ color: '#fff', fontSize: 13, fontWeight: '600', marginBottom: 4 }}>
                            {item.item || item.codigo}
                          </div>
                          <div style={{ color: '#555', fontSize: 11, marginBottom: 10 }}>
                            {item.codigo} · {item.marca}
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                              <div style={{ color: '#555', fontSize: 10 }}>Stock</div>
                              <div style={{ color: item.stock > 0 ? '#4caf50' : '#555', fontSize: 15, fontWeight: 'bold' }}>
                                {item.stock > 0 ? item.stock : '—'}
                              </div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                              <div style={{ color: '#555', fontSize: 10 }}>Costo u.</div>
                              <div style={{ color: '#4cc9f0', fontSize: 13 }}>
                                {item.costo > 0 ? `$${fmt(item.costo)}` : '—'}
                              </div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                              <div style={{ color: '#555', fontSize: 10 }}>Valor</div>
                              <div style={{ color: '#fff', fontSize: 13 }}>
                                {item.valor > 0 ? `$${fmt(item.valor)}` : '—'}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          <div style={{ color: '#555', fontSize: 12, textAlign: 'right', marginTop: 8 }}>
            {gruposFiltrados.length} grupos · {gruposFiltrados.reduce((a, g) => a + g.n_items, 0)} items afectados
          </div>
        </>
      )}
    </div>
  );
}
